import ApiService from './api';
import qs from 'qs';

const ProfileService = {
  getProfile: async function (id) {
    const query = `${process.env.VUE_APP_ROOT_API_ENV}/partners/selectprofile?username=${id}`;
    try {
      const res = await ApiService.get(query);
      if (res && res.status) {
        console.log('-- get profile data ok --');
        return res.data;
      }
      console.warn('!! get profile data invalid');
      return false;
    } catch (error) {
      console.warn('!! get profile data error ', error);
      return false;
    }
  },

  saveProfile: async function (data){
    const query = `${process.env.VUE_APP_ROOT_API_ENV}/partners/saveprofile`;
    try{
      const res = await ApiService.post(query, qs.stringify(data));
      if(res && res.status) {
        console.log('-- save profile data ok --');
        return res.data;
      }
      return false;
    } catch (error) {
      console.warn('!! save profile data error ', error);
      return false;
    }
  }
}

export default ProfileService;
